const REGO_VALIDATION_ERROR_MESSAGE = "Please enter a valid registration";
const ERROR_VEHICLE_MANUFACTURER = 'Vehicle manufacturer must be Toyota.';
const NOT_MY_VEHICLE_PAYLOAD = "After you submit this form, we\u2019ll contact you to confirm your vehicle details";
const API_REGO_MISMATCH_ERROR_MESSAGE = "The information you entered does not match our records, please check and try again.";
const NOVATED = "novated";
const BROCHURE = "brochure";
const B2B = "b2b";
const FINANCE = "finance";
const INSURANCE = "insurance";
const VEHICLE = "vehicle";
const FLEET = "fleet";
const ROADSIDE = "roadside";
const ACCOUNT = "account";
const APPS = "apps";
const APPS_AND_ACCOUNT = "appsandaccount";
const SPACED_APPS_AND_ACCOUNT = "apps and account";
const COMPLAINT = "complaint";
const TOYOTA = "Toyota";

// Helper function to set form controls to pristine and untouched
function resetFormControls(formControls) {
  formControls.forEach(control => {
    if(control){
      control.$setPristine();
      control.$setUntouched();
    }
  });
}

const scrollToMandatoryErrorMessage = () => {
  setTimeout(() => {
    const h4Elements = document.querySelectorAll('#ownAToyotaSec h4');
    const visibleH4 = Array.from(h4Elements).find(h4 => h4.offsetParent !== null);

    if(visibleH4) {
      const yOffset = -100; // This offset was added to cater for fixed header
      const yPosition = visibleH4.getBoundingClientRect().top + window.scrollY + yOffset;

      window.scrollTo({ top: yPosition, behavior: 'smooth' });
    }
  }, 100);
};

// Utility function to extract year from a "YYYY-MM" format
function extractYear(manufacturedYear) {
  return manufacturedYear ? manufacturedYear.split('-')[0] : '';
}

(function (angular, ToyotaForms, ToyotaConsts) {
  "use strict";

  angular.module("Toyota.Directives").
    directive("formsContactUsUplift", ["$filter", "API", function ($filter, API) {
      formsContactUsController.$inject = ["$scope", "AddressById", "$attrs", '$interval',"$analytics"];
      function formsContactUsController($scope, AddressById, $attrs, $interval, $analytics) {
        $scope.init = function () {
          $scope.fields = {
            firstname: "",
            lastname: "",
            phone: "",
            email: "",
            carSelectionOne: "",
            carSelectionOwnToyota: "",
            ownAToyota: "",
            contactType: "",
            enquiryType: "",
            enquirySubType: "",
            enquiryTypeAnalyticsLabel: "",
            message: "",
            formName: "",
            campaignCode: "",
            address: "",
            registrationMainForm: "",
            state: "",
            registration: "",
            addressId: "",
            toyotaCustomerFleet: "",
            toyotaCustomerFinance: "",
            customerNumber: "",
            assistPreferenceFinanceUplift: "",
            assistPreferenceInsuranceUplift: "",
            assistPreferenceAppsAndAccount: "",
            insurancePolicyType: "",
            contactPreference: "",
            employerOrEmployee: "",
            positionTitle: "",
            industry: "",
            haveNovatedLease: "",
            hearAboutUs: "",
            fleetCompanyName: "",
            novatedCompanyName: "",
            companyContact: "",
            numberOfEmployees: "",
          };

          $scope.form = {
            submitting: false,
            completed: false,
            success: false,
          };

          $scope.vehicleModelList = ["carSelectionOne"];

          // UI flags
          $scope.showMOI = false;
          $scope.showRego = false;
          $scope.showAddress = false;
          $scope.showFinanceSec = false;
          $scope.showInsuranceSec = false;
          $scope.showOwnAToyotaSec = true;
          $scope.showInsurancePolicyType = false;
          $scope.showFleetSec = false;
          $scope.showRoadsideAssistanceSec = false;
          $scope.showAppsAndAccountSec = false;
          $scope.showForm = false;
          $scope.isComplaint = false;
          $scope.enquiryTypes = {};
          $scope.complaintEnquiryTypes = {};
          $scope.questionEnquiryTypes = {};
          $scope.enquiryTypePreSelected = '';
          $scope.showNotMyVehicleFallbackText = false;
          $scope.mandatoryButtonClicked = "";
          $scope.isVehicleConfirmed = false;
          $scope.showConfirmVehicleError = false;
          $scope.cannotFindVehicleFlag = false;
          $scope.showVehicleDetailInputFields = false;
          $scope.enquiryTypeSelected = false;

          $scope.resetAllInputFields = function () {
            Object.keys($scope.fields).forEach(function (key) {
              if (!['enquiryType', 'contactType', 'formName', 'campaignCode'].includes(key)) {
                $scope.fields[key] = "";
              }
            });
          }

          $scope.resetOwnAToyoTaFields = function () {
            $scope.apiService = {};
            $scope.apiService.loading = false;
            $scope.isRegoValidatedByApi = false;
            $scope.regoNumber = "";
            $scope.vehicleDescription = "";
            $scope.isVehicleConfirmed = false;
            $scope.regoApiErrorMessage = REGO_VALIDATION_ERROR_MESSAGE;
            $scope.isVehicleFound = true;
            $scope.vehicleModel = "";
            $scope.hasCheckedRego = undefined;
            $scope.fields.state = "";
            $scope.fields.registration = "";
            $scope.isRegistrationCheckBtnDisabled = true;
            $scope.showNotMyVehicleFallbackText = false;
            $scope.cannotFindVehicleFlag = false;
          }

          $scope.handleNotMyVehicleBtnClick = function () {
            $scope.isVehicleConfirmed = false;
            $scope.isRegoValidatedByApi = false;
          }

          $scope.handleConfirmVehicleBtnClick = function () {
            $scope.showConfirmVehicleError = false;
            $scope.isVehicleConfirmed = true;
            $scope.mandatoryButtonClicked = 'yes';
          }

          $scope.handleChangeVehicleBtnClick = function () {
            $scope.isVehicleConfirmed = false;
            $scope.isRegoValidatedByApi = false;
            $scope.mandatoryButtonClicked = 'no';
          }

          $scope.handleVehicleNotFoundBtnClick = function () {
            $scope.cannotFindVehicleFlag = true;
            $scope.fields.state = "";
            $scope.fields.registration = "";
            $scope.isRegoValidatedByApi = true;
            $scope.wfm.registration.$setPristine();
            $scope.wfm.registration.$setUntouched();
            $scope.wfm.state.$setPristine();
            $scope.wfm.state.$setUntouched();
            $scope.showNotMyVehicleFallbackText = true;
            $scope.mandatoryButtonClicked = 'yes';
            $scope.showConfirmVehicleError = false;
            $scope.showVehicleDetailInputFields = false;
          }

          $scope.handleSubmitBtnClick = function () {
            if($scope.wfm.$valid) {
              $scope.submit();
            } 
            else {
              if($scope.fields.ownAToyota === 'true' && !$scope.isVehicleFound && !$scope.cannotFindVehicleFlag) {
                $scope.showConfirmVehicleError = true;
              }
            }
          }

          $scope.$on("address-tag-added", function (event, data) {
            $scope.fields.addressId = data.data.info.search_result_id;

            var addressTask = AddressById(data.data.info.search_result_id);

            addressTask.then(function (data) {
              $scope.fields.address = data;
            });
          });

          $scope.$on("address-tag-removed", function () {
            $scope.fields.address = "";
          });

          // reset input fields on topic type change
          $scope.$watch("fields.contactType", function (value) {
            const isDefined = !!value;
            if(isDefined && !$scope.enquiryTypeSelected){
              $analytics.eventTrack('form_start_corporate_contact_us', { formName: 'Corporate - Contact Us Form' });
              $scope.enquiryTypeSelected = true;
            }
            $scope.isComplaint = isDefined && value.toLowerCase().includes(COMPLAINT);
            $scope.loadEnquiryTypes($scope.isComplaint ? $scope.complaintEnquiryTypes : $scope.questionEnquiryTypes);
            $scope.showEnquiryType = isDefined && value !== "";
            $scope.selectFieldOption('enquiryTypes', 'enquiryType', $scope.enquiryTypePreSelected)
            if ($scope.wfm.$dirty) {
              $scope.fields.enquiryType = "";
              $scope.resetAllInputFields();
              $scope.wfm.$setPristine();
              $scope.wfm.$setUntouched();
            }
            $scope.wfm.$submitted = false;
          });

          $scope.$watch('fields.ownAToyota', function (newValue, oldValue, scope) {
            if(!scope.wfm) {
              return;
            }

            if(newValue === 'false') {
              scope.mandatoryButtonClicked = 'yes';
              scope.showConfirmVehicleError = false;
              scope.isRegoValidatedByApi = false;
              scope.showNotMyVehicleFallbackText = false;
              scope.showVehicleDetailInputFields = false;
            }

            if(newValue === 'true') {
              scope.mandatoryButtonClicked = 'no';
              scope.showVehicleDetailInputFields = true;
            }

            scope.resetOwnAToyoTaFields();
            resetFormControls([scope.wfm.registration, scope.wfm.state]);
          });

          $scope.$watch("fields.enquiryType", function (value) {
            if ($scope.wfm.enquiryType.$dirty) {
              $scope.resetAllInputFields();
            }

            $scope.wfm.$submitted = false;
            Object.keys($scope.wfm).filter(field => field[0] !== '$' && field !== 'enquiryType').forEach(field => {
              $scope.wfm[field].$setPristine();
              $scope.wfm[field].$setUntouched();
            });

            $scope.$evalAsync(() => {
              $scope.fields.enquiryTypeAnalyticsLabel = $scope.getEnquiryTypeAnalyticsLabel(value);
            });

            const valueLowerCase = value ? value.toLowerCase() : "";

            // Reset all sections to default visibility
            const sections = {
              showMOI: false,
              showRego: false,
              showAddress: false,
              showFinanceSec: false,
              showInsuranceSec: false,
              showInsurancePolicyType: false,
              showOwnAToyotaSec: true, // Default to true
              showFleetSec: false,
              showRoadsideAssistanceSec: false,
              showAppsAndAccountSec: false,
              showForm: !!value
            };

            // Configuration for conditions
            const conditions = [
              { key: BROCHURE, sections: ["showMOI", "showAddress"] },
              { key: FINANCE, sections: ["showFinanceSec"] },
              { key: INSURANCE, sections: ["showInsuranceSec"], additionalCheck: () => $scope.fields.assistPreferenceInsuranceUplift.toLowerCase().indexOf("comprehensive") > -1, additionalSections: ["showRego", "showInsurancePolicyType"] },
              { key: VEHICLE, sections: ["showMOI"] },
              { key: FLEET, sections: ["showFleetSec"] },
              { key: ROADSIDE, sections: ["showRego", "showRoadsideAssistanceSec"], override: { showOwnAToyotaSec: false } },
              { key: ACCOUNT, sections: ["showAppsAndAccountSec"] }
            ];

            conditions.forEach(condition => {
              if (valueLowerCase.indexOf(condition.key) > -1) {
                condition.sections.forEach(section => sections[section] = true);
                if (condition.additionalCheck && condition.additionalCheck()) {
                  condition.additionalSections.forEach(section => sections[section] = true);
                }
                if (condition.override) {
                  Object.keys(condition.override).forEach(key => sections[key] = condition.override[key]);
                }
              }
            });

              // Apply visibility settings
            Object.keys(sections).forEach(section => $scope[section] = sections[section]);
          });

          $scope.$watch("fields.assistPreferenceInsuranceUplift", (newValue, oldValue) => {
            if (newValue !== oldValue) {
              const show = newValue.toLowerCase().includes("comprehensive");
              $scope.showRego = show;
              $scope.showInsurancePolicyType = show;
            }
          });
        };

        $scope.init();
        $scope.resetOwnAToyoTaFields();

        $scope.getEnquiryTypeAnalyticsLabel = (selectedEnquiryType) => $scope.isSelectedEnquiryTypeNovatedB2B(selectedEnquiryType) ? `${selectedEnquiryType} - ${$scope.fields.enquirySubType.toUpperCase()}` : selectedEnquiryType;

        $scope.isSelectedEnquiryTypeNovatedB2B = (selectedEnquiryType) => selectedEnquiryType?.toLowerCase().includes(NOVATED) && $scope.fields.enquirySubType === B2B;

        $scope.isNovatedB2B = () => $scope.fields.enquiryType.toLowerCase().includes(NOVATED) && $scope.fields.enquirySubType === B2B;

        $scope.isNovatedB2C = () => $scope.fields.enquiryType.toLowerCase().includes(NOVATED) && $scope.fields.enquirySubType !== B2B;

        //Rego number field validator
        // TODO: This code will need a refactor. It was copied from the existing codebase
        // JIRA: https://toyotaau.atlassian.net/browse/SIR-6557
        $scope.$watchGroup(
          [
            'wfm.state.$viewValue',
            'wfm.registration.$viewValue', // repaint after each char typed
            'isRegoValidationInProgress', // repaint after validation completed
            'wfm.registration.$error.regoApiHasRunAndValueIsValid'
          ], function (newValues, oldValues, scope) {
            if(scope.cannotFindVehicleFlag) {
              return;
            }

            var regoControl = $scope.wfm.registration;
            if(!regoControl) {
              return;
            }

            // invalidate fields once new key has entered
            if (newValues[1] !== oldValues[1] || newValues[0] !== oldValues[0]) {
              scope.regoApiErrorMessage = REGO_VALIDATION_ERROR_MESSAGE;
              scope.isRegoDirty = true;
              scope.isRegoValidatedByApi = false;
              scope.hasCheckedRego = false;
              regoControl.$setDirty();
              regoControl.$validate();
            }

            var isRegoApiError = newValues[3];
            if (isRegoApiError) {
              scope.regoApiErrorMessage = API_REGO_MISMATCH_ERROR_MESSAGE;
            }
          });

        //Check registration button logic
        $scope.$watchGroup(
          [
            'wfm.registration.$viewValue', // repaint after each char typed
            'wfm.state.$viewValue',
          ], function (newValues, oldValues, scope) {
            if (!scope.wfm || !scope.wfm.registration || !scope.wfm.state) {
              return; // Do nothing and return early
            }
            const formControl = scope.wfm;
            scope.isRegistrationCheckBtnDisabled = formControl.registration.$invalid || formControl.state.$invalid;
          });

        $scope.validateRego = async function () {
          $scope.showConfirmVehicleError = false;
          const regoControl = $scope.wfm.registration;
          const rego = regoControl.$viewValue; // Use pre-validation value
          const state = $scope.fields.state;
          const accessToken = $scope.servicePricingTool.tokenService.accessToken;
          const urlVehicleInfo = `${ToyotaConsts.API.ServiceQuote.VehicleInfo}?registrationNumber=${rego}&state=${state}`;
        
          $scope.isRegoValidationInProgress = false;
          $interval($scope.servicePricingTool.refreshAccessToken, $scope.servicePricingTool.tokenService.interval);
        
          $scope.apiService.loading = true;
          $scope.hasCheckedRego = true;
        
          try {
            const response = await API.get(urlVehicleInfo, { Authorization: `Bearer ${accessToken}` });
            const manufacturer = response.data.manufacturer;

            if (manufacturer !== TOYOTA) {
              throw new Error(ERROR_VEHICLE_MANUFACTURER);
            }

            $scope.isRegoValidatedByApi = true;
            $scope.vehicleDescription = response.data.vehicleDescription;
            $scope.regoNumber = response.data.registrationNumber;
            $scope.manufacturedYear = extractYear(response.data.manufacturedYear);
            $scope.vin = response.data.vin;
            $scope.vehicleModel = response.data.model;
          } catch (error) {
            $scope.isVehicleFound = false;
            $scope.isRegoValidatedByApi = false;
          } finally {
            $scope.isRegoValidationInProgress = true;
            $scope.isRegoDirty = false;
            $scope.apiService.loading = false;
            regoControl.$setDirty();
            regoControl.$validate();
            if (!$scope.vehicleDescription) {
              $scope.isRegoValidatedByApi = false;
              $scope.isVehicleFound = false;
            }
          }
        
          $scope.$digest();
        };

        $scope.vehicleInvalid = function (fieldId, isRequired) {
          const enquiryTypeLower = $scope.fields.enquiryType.toLowerCase();
          const isBrochureOrVehicle = enquiryTypeLower.includes(BROCHURE) || enquiryTypeLower.includes(VEHICLE);

          // Validate only for the first vehicle model in the list
          if (fieldId === $scope.vehicleModelList[0]) {
            return isBrochureOrVehicle && $scope.fields[fieldId] === "" && ($scope.wfm[fieldId].$touched || $scope.wfm.$submitted);
          }

          // For other fields, check if required and form interaction state
          return isRequired && ($scope.wfm[fieldId].$touched || $scope.wfm.$submitted) && !$scope.wfm[fieldId].$valid;
        };

        $scope.vehicleValid = function (fieldId, isRequired) {
          const enquiryTypeLower = $scope.fields.enquiryType.toLowerCase();
          const isBrochureOrVehicle = enquiryTypeLower.includes(BROCHURE) || enquiryTypeLower.includes(VEHICLE);

          if (fieldId === $scope.vehicleModelList[0]) {
            return isBrochureOrVehicle && $scope.fields[fieldId] !== "" && $scope.wfm[fieldId].$touched;
          }

          return isRequired && $scope.wfm[fieldId].$touched && $scope.wfm[fieldId].$valid;
        };

        $scope.addressInValid = () => !$scope.fields.addressId && ($scope.wfm.address?.$touched || $scope.wfm.$submitted);

        $scope.addressValid = () => $scope.fields.addressId && $scope.wfm.address?.$touched;

        $scope.isFinanceCustomerTypeRequired = () => $scope.fields.enquiryType.toLowerCase().includes(FINANCE) && !$scope.isComplaint;

        $scope.isFleetCustomerTypeRequired = function () {
          return $scope.fields.enquiryType.toLowerCase().indexOf(FLEET) > -1 && !$scope.isComplaint;
        };

        $scope.isPostcodeRequired = function () {
          const enquiryTypeLower = $scope.fields.enquiryType.toLowerCase();
          return enquiryTypeLower.includes(FINANCE) ||
                enquiryTypeLower.includes(INSURANCE) ||
                enquiryTypeLower.includes(FLEET) ||
                $scope.isNovatedB2C();
        };

        $scope.isAssistPreferenceRequired = function (fieldId, isRequired) {
          if (!$scope.isComplaint && isRequired) {
            const enquiryTypeLower = $scope.fields.enquiryType.toLowerCase();
            const fieldIdLower = fieldId.toLowerCase();
        
            const keywords = [FINANCE, INSURANCE, SPACED_APPS_AND_ACCOUNT];
            const fieldKeywords = [FINANCE, INSURANCE, APPS_AND_ACCOUNT];
        
            for (let i = 0; i < keywords.length; i++) {
              if (enquiryTypeLower.includes(keywords[i]) && fieldIdLower.includes(fieldKeywords[i])) {
                return true;
              }
            }
          }
          return false;
        };

        $scope.isInsurancePolicyTypeRequired = (isRequired) => $scope.fields.enquiryType.toLowerCase().includes(INSURANCE) && $scope.showInsurancePolicyType || isRequired;
        
        $scope.isRegistrationRequired = (fieldId, isRequired) => $scope.fields.ownAToyota === 'true' && !$scope.cannotFindVehicleFlag && isRequired;

        $scope.isStateRequired = (isRequired) => $scope.fields.ownAToyota === 'true' && !$scope.cannotFindVehicleFlag && isRequired;

        $scope.isEmployerOrEmployeeRequired = () => $scope.isNovatedB2C();

        $scope.isNovatedLeaseCheckRequired = () => $scope.isNovatedB2C();

        $scope.isCompanyNameRequired = () => $scope.isNovatedB2B();

        $scope.isCompanyContactRequired = () => $scope.isNovatedB2B();

        $scope.isNumberOfEmployeesRequired = () => $scope.isNovatedB2B();

        $scope.selectFieldOption = (listId, fieldId, selected) => {
          if (selected && $scope[listId]) {
            selected = selected.toLowerCase();

            $scope[listId].forEach(function (currentValue) {
              if (currentValue.Text.toLowerCase() === selected) {
                $scope.fields[fieldId] = currentValue.Value;
              }
            });
          }
        };

        $scope.getData = function () {
          const enquiryTypeLower = $scope.fields.enquiryType.toLowerCase();

          const baseContactUsData = {
            ContactType: $scope.fields.contactType,
            EnquiryType: $scope.fields.enquiryType,
            Message: $scope.fields.message,
            FirstName: $scope.fields.firstname,
            LastName: $scope.fields.lastname,
            Email: $scope.fields.email,
            Phone: $scope.fields.phone,
            OwnAToyota: $scope.fields.ownAToyota,
            Agreement: false,
            FormName: $scope.fields.formName,
            CampaignCode: $scope.fields.campaignCode,
            ContactPreference: $scope.fields.contactPreference,
          };

          const getCustomerVehicleData = () => {
            if($scope.fields.ownAToyota !== 'true') {
              return {};
            }

            return $scope.isVehicleConfirmed !== true ? {
              State: "",
              Registration: '',
              CarSelectionOwnToyota: '',
              Year: '',
              VIN: '',
              Model: '',
              VehicleDescription: NOT_MY_VEHICLE_PAYLOAD,
            } : {
              State: $scope.fields.state,
              Registration: $scope.regoNumber,
              CarSelectionOwnToyota: $scope.fields.carSelectionOwnToyota,
              Year: $scope.manufacturedYear,
              VIN: $scope.vin,
              Model: $scope.vehicleModel,
              VehicleDescription: $scope.vehicleDescription,
            };
          }


          const getBrochureData = () => {
            return {
              CarSelectionOne: $scope.fields.carSelectionOne,
              ...(!!$scope.fields.address && {
                Address: {
                  street: $scope.fields.address.street_address,
                  suburb: $scope.fields.address.suburb,
                  postcode: $scope.fields.address.postcode,
                  state: $scope.fields.address.state,
                }
              })
            };
          }

          const getFinanceData = () => {
            return {
              ...($scope.fields.customerNumber && { CustomerNumber: $scope.fields.customerNumber }),
              ...(!$scope.isComplaint && {
                PostcodeMainForm: $scope.fields.postcodeMainForm,
                AssistPreference: $scope.fields.assistPreferenceFinanceUplift,
                ToyotaCustomer: $scope.fields.toyotaCustomerFinance,
                RegistrationMainForm: $scope.fields.registrationMainForm,
              }),
            };
          }

          const getInsuranceData = () => {
            return {
              ...($scope.showInsurancePolicyType && { InsurancePolicyType: $scope.fields.insurancePolicyType }),
              ...(!$scope.isComplaint && {
                PostcodeMainForm: $scope.fields.postcodeMainForm,
                AssistPreference: $scope.fields.assistPreferenceInsuranceUplift,
                RegistrationMainForm: $scope.fields.registrationMainForm,
              }),
            };
          }

          const getNovatedB2CData = () => {
            return {
              EnquirySubType: $scope.fields.enquirySubType || "B2C",
              PostcodeMainForm: $scope.fields.postcodeMainForm,
              EmployerOrEmployee: $scope.fields.employerOrEmployee,
              PositionTitle: $scope.fields.positionTitle,
              Industry: $scope.fields.industry,
              HaveNovatedLease: $scope.fields.haveNovatedLease,
              HearAboutUs: $scope.fields.hearAboutUs,
            };
          }

          const getNovatedB2BData = () => {
            return {
              EnquirySubType: $scope.fields.enquirySubType,
              CompanyName: $scope.fields.novatedCompanyName,
              CompanyContact: $scope.fields.companyContact,
              NumberOfEmployees: $scope.fields.numberOfEmployees,
            };
          }

          const getAppsData = () => {
            return {
              ...(!$scope.isComplaint &&
                { EnquirySubType: $scope.fields.assistPreferenceAppsAndAccount }),
            };
          }

          const getFleetData = () => {
            return {
              ToyotaCustomer: $scope.fields.toyotaCustomerFleet,
              PostcodeMainForm: $scope.fields.postcodeMainForm,
              CompanyName: $scope.fields.fleetCompanyName,
            };
          }

          const getRoadsideData = () => {
            return {
              RegistrationMainForm: $scope.fields.registrationMainForm,
            };
          }

          const getVehicleData = () => {
            return {
              CarSelectionOne: $scope.fields.carSelectionOne,
            };
          }

          const contactUsData = {
            ...baseContactUsData,
            ...getCustomerVehicleData(),
            ...enquiryTypeLower.includes(BROCHURE) && getBrochureData(),
            ...enquiryTypeLower.includes(FINANCE) && getFinanceData(),
            ...enquiryTypeLower.includes(INSURANCE) && getInsuranceData(),
            ...$scope.isNovatedB2C() && getNovatedB2CData(),
            ...$scope.isNovatedB2B() && getNovatedB2BData(),
            ...enquiryTypeLower.includes(APPS) && getAppsData(),
            ...enquiryTypeLower.includes(FLEET) && getFleetData(),
            ...enquiryTypeLower.includes(ROADSIDE) && getRoadsideData(),
            ...enquiryTypeLower.includes(VEHICLE) && getVehicleData(),
          }

          return contactUsData;
        };

        $scope.submit = async function () {
          const enquiryTypeLower = $scope.fields.enquiryType.toLowerCase();
          const isBrochureOrVehicle = enquiryTypeLower.includes(BROCHURE) || enquiryTypeLower.includes(VEHICLE);
          const isBrochureWithoutAddress = enquiryTypeLower.includes(BROCHURE) && (!$scope.fields.addressId || !$scope.fields.address);
          const isCarSelectionEmpty = $scope.fields.carSelectionOne === "";

          if ((isBrochureOrVehicle && isCarSelectionEmpty && !$scope.isComplaint) || isBrochureWithoutAddress) {
            return;
          }

          if($scope.mandatoryButtonClicked === 'no') {
            $scope.showConfirmVehicleError = true;
            scrollToMandatoryErrorMessage();
            return;
          }

          $scope.form.submitting = true;

          const url = $filter("formatArgs")(ToyotaForms.API.FormSubmission.ContactUsUplift);
          const data = $scope.getData();

          try {
            const req = await API.post(url, data);
            $scope.form.submitting = false;
            $scope.form.completed = true;
            $scope.form.success = req.data.isSuccessful;
            $scope.$broadcast($scope.form.success ? "form-success" : "form-failure");
          } catch (error) {
            $scope.form.submitting = false;
            $scope.form.success = false;
            $scope.$broadcast("form-server-error");
          } finally {
            $scope.$apply();
            setTimeout(() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }, 100); // Added a delay so that UI changes are applied before scrolling
          }
        };

        $scope.loadEnquiryTypes = function (enquiryTypes) {
          $scope.showEnquiryType = enquiryTypes !== undefined && enquiryTypes !== "";
          $scope.enquiryTypes = enquiryTypes;
        };
      }

      return {
        scope: true,
        restrict: "A",
        controller: formsContactUsController,
        controllerAs: "fc",
        bindToController: true,
        link: function ($scope, $element, $attrs) {
        },
      };
    },
    ]);
})(window.angular, window.ToyotaForms, window.ToyotaConsts);
